var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomKeyOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94318 2.66667C7.38409 1.11333 5.87045 0 4.09091 0C1.83409 0 0 1.79333 0 4C0 6.20667 1.83409 8 4.09091 8C5.87045 8 7.38409 6.88667 7.94318 5.33333H10.9091V8H13.6364V5.33333H15V2.66667H7.94318ZM4.09091 5.33333C3.34091 5.33333 2.72727 4.73333 2.72727 4C2.72727 3.26667 3.34091 2.66667 4.09091 2.66667C4.84091 2.66667 5.45455 3.26667 5.45455 4C5.45455 4.73333 4.84091 5.33333 4.09091 5.33333Z",
    fill: "#919696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomKeyOff);
export default __webpack_public_path__ + "static/media/RoomKeyOff.963871fe5f892cec9f4e808583ec2fcf.svg";
export { ForwardRef as ReactComponent };